module.exports = __webpack_public_path__ + "static/img/phone.290f0245.png";